module.exports = __webpack_public_path__ + "img/csr8.b707a594.jpg";